import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {UserLaneService} from './services/user-lane.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers:[
    UserLaneService
  ]
})
export class UserLaneModule { }
